import React, { memo } from 'react';
import classnames from 'classnames';

import { Drawer } from '../material-ui/Drawer';
import { useStyles } from './useStyles';

export const SidebarBase = memo(({ visibility, handleClose, anchor, navigationBarVisibility, children }) => {
    const classes = useStyles();

    return (
        <Drawer
            open={visibility}
            anchor={anchor}
            onClose={handleClose}
            className={classnames(classes.drawerClass, {
                [classes.drawerOpenClass]: visibility,
                [classes.drawerCloseClass]: !visibility,
            })}
            classes={{
                paper: classnames(
                    {
                        [classes.drawerOpenClass]: visibility,
                        [classes.drawerCloseClass]: !visibility,
                    },
                    classes.drawerPaper,
                    navigationBarVisibility && classes.drawerPaddingBottom
                ),
            }}
        >
            {children}
        </Drawer>
    );
});

SidebarBase.displayName = 'SidebarBase';
